export const escapeHyphen = (str) => {
  return str.replace(/-/g, ' ');
};

export const dashToCamelCase = (str) => {
  return str.replace(/-([a-z])/g, (g) => {
    return g[1].toUpperCase();
  });
};

export const camelCaseToDash = (str) => {
  return str
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([0-9])([^0-9])/g, '$1-$2')
    .replace(/([^0-9])([0-9])/g, '$1-$2')
    .replace(/-+/g, '-')
    .toLowerCase();
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const rgxEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const trim = (size) => (str) => {
  if (!size || str?.length <= size) {
    return str;
  }
  return str ? str.slice(0, size) + '...' : null;
};

export const getNavigator = (str) => {
  if (str?.includes('Safari') && !str?.includes('Chrome' || 'Chromium')) {
    return 'safari';
  } else if (str?.includes('Edg' || 'MSIE' || 'Trident')) {
    return 'IE';
  }
  return 'other';
};

export const slugify = (str) =>
  str
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');
